import React from 'react';
import classNames from 'classnames';

import { ToggleComponentProps } from './toggle.component.types';
import styles from './toggle.module.scss';

export const ToggleComponent = (props: ToggleComponentProps) => {
  const { value = false, indicator = true, disabled = false, onChange } = props;

  const stateIndicatorClassNames = classNames(styles.stateIndicator, {
    [styles.stateIndicatorActive]: value,
    [styles.stateIndicatorDisabled]: disabled,
  });

  const inputClassNames = classNames(styles.input, {
    [styles.inputDisabled]: disabled,
  });

  const sliderClassNames = classNames(styles.slider, {
    [styles.sliderDisabled]: disabled,
  });

  const handleOnChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (!disabled) {
      onChange(event);
    }
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.toggle}>
        <input {...props} onChange={handleOnChange} type="checkbox" className={inputClassNames} checked={value} />
        <span className={sliderClassNames} />
      </div>
      {indicator && <span className={stateIndicatorClassNames}>{value ? 'on' : 'off'}</span>}
    </div>
  );
};
